import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import "@fontsource/noto-sans-jp/900.css"
import "@fontsource/raleway/300.css"

type PropTypes = {
  title: string
  text: string
}

const HomeIntroParagraphStyles = styled.div`
  margin-bottom: 35px;
  h2 {
    font-weight: 900;
    font-size: 40px;
    margin: 0 0 15px;
  }
  p {
    font-weight: 300;
    font-size: 24px;
    line-height: 35px;
    margin: 0;
  }
  @media screen and (min-width: 500px) {
    h2 {
      font-size: 50px;
    }
  }
`

const HomeIntroParagraph: React.FC<PropTypes> = ({ title, text }) => {
  return (
    <HomeIntroParagraphStyles id="HomePage-homeIntroParagraph">
      <h2>{title}</h2>
      <p>{text}</p>
    </HomeIntroParagraphStyles>
  )
}

export default HomeIntroParagraph
